import { legacyRoleRank } from 'app/types/roles'

/**
 * Types the Activities list never shows. They have their own surfaces (schedule,
 * contact timeline) and would swamp a call/form/text list.
 */
export const ACTIVITIES_TYPE_EXCLUSION = `typeId:* AND NOT type:(Appointment OR Patient OR Note OR Change OR Milestone)`

const QUEUED_CALL_EXCLUSION = `AND NOT tags:(Call in Queue) AND NOT description:(Call in Queue)`

/** The Activities page's default filter. Org admins are the only users who see queued calls. */
export function activitiesExclusionTerm(user: { role?: number | null } | undefined): string {
  if (user?.role === legacyRoleRank.orgAdmin) return ACTIVITIES_TYPE_EXCLUSION
  return `${ACTIVITIES_TYPE_EXCLUSION} ${QUEUED_CALL_EXCLUSION}`
}
